
import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChartContainer } from "@/components/ui/chart";
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer, Tooltip } from 'recharts';

interface ResultRadarChartProps {
  scores: {
    O: number;
    C: number;
    E: number;
    A: number;
    N: number;
  };
}

export default function ResultRadarChart({ scores }: ResultRadarChartProps) {
  // Transform scores for the radar chart
  const chartData = [
    {
      trait: "Abertura",
      fullName: "Abertura à Experiência",
      value: scores.O * 20, // Scale to 0-100
      fill: "#9b87f5", // Purple
    },
    {
      trait: "Conscienciosidade",
      fullName: "Conscienciosidade",
      value: scores.C * 20, // Scale to 0-100
      fill: "#60a5fa", // Blue
    },
    {
      trait: "Extroversão",
      fullName: "Extroversão",
      value: scores.E * 20, // Scale to 0-100
      fill: "#f97316", // Orange
    },
    {
      trait: "Amabilidade",
      fullName: "Amabilidade",
      value: scores.A * 20, // Scale to 0-100
      fill: "#34d399", // Green
    },
    {
      trait: "Neuroticismo",
      fullName: "Neuroticismo",
      value: scores.N * 20, // Scale to 0-100
      fill: "#f87171", // Red
    }
  ];

  // Chart config for colors
  const chartConfig = {
    O: { color: "#9b87f5" },
    C: { color: "#60a5fa" },
    E: { color: "#f97316" },
    A: { color: "#34d399" },
    N: { color: "#f87171" }
  };

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-2 shadow rounded border">
          <p className="font-medium">{data.fullName}</p>
          <p className="text-sm text-gray-600">
            Pontuação: {(data.value / 20).toFixed(1)} (de 5)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="h-80 w-full"
    >
      <ChartContainer config={chartConfig} className="h-full">
        <RadarChart outerRadius="80%" data={chartData}>
          <PolarGrid />
          <PolarAngleAxis dataKey="trait" />
          <PolarRadiusAxis domain={[0, 100]} tickCount={6} />
          <Radar
            name="Perfil de Personalidade"
            dataKey="value"
            stroke="#13265a"
            fill="#13265a"
            fillOpacity={0.6}
          />
          <Tooltip content={<CustomTooltip />} />
        </RadarChart>
      </ChartContainer>
    </motion.div>
  );
}
